import React, { useEffect, useState } from "react";
// import test1 from "../assets/tertim1.png";
import { Carousel } from "react-bootstrap";
import logo from "../assets/footer logo.png";
import { BsTwitterX } from "react-icons/bs";
import { BsInstagram } from "react-icons/bs";
import { BsLinkedin } from "react-icons/bs";
import { Link } from "react-router";

import RollingText1 from "./RollingText1";
import toast, { Toaster } from "react-hot-toast";
// import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { FaCheckCircle } from "react-icons/fa";
import { BiCommentError } from "react-icons/bi";
// import about1 from '../assets/aboutus/Rectangle 39.png'
import { useNavigate } from "react-router-dom";


const notify = () => toast.success("Successfully Submitted!");
const words = ["Connection", "Perspective", "Companionship"];
const Form = ({ getStartedRef }) => {

  const navigate = useNavigate();

  const [index, setIndex] = useState(0);
  const [formData, setFormData] = useState({
    name:"",
    email:"",
    number:"",
    desc:""
  });

  const API_URL = "https://us-central1-patchupashik.cloudfunctions.net/submitContactForm";//process.env.REACT_APP_CONTACT_API_URL;

  const [show, setShow] = useState(false);
  const [successError, setSuccessError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setShow(false);
    setFormData(
      {
        name:"",
        email:"",
        number:"",
        desc:""
      }
    )
  }
  const handleShow = () => setShow(true);
  
  useEffect(() => {


    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 1500); // Change word every 1.5 seconds

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (
  formData.name.trim() !== "" &&
  formData.email.trim() !== "" &&
  formData.number.trim() !== "" &&
  formData.desc.trim() !== ""
) {
  setSuccessError(true);
} else {
  setSuccessError(false);
}
  }, [formData])

  const handleFormSubmit = async () => {
    if (
      !formData.name.trim() ||
      !formData.email.trim() ||
      !formData.number.trim() ||
      !formData.desc.trim()
    ) {
      handleShow();
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fullName: formData.name,
          email: formData.email,
          phoneNumber: formData.number,
          situation: formData.desc,
        }),
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      setSuccessError(true);
      handleShow();
    } catch (error) {
      setSuccessError(false);
      handleShow();
      console.error("Form submission error:", error);
    } finally {
      setIsLoading(false);
    }
  }
  console.log(formData)
  const testimonials = [
  {
    name: "Avinash Shukla",
    service: "Check Compatibility",
    review:
      "Through therapy I understood myself better and figured out what I really want from a life partner",
  },
  {
    name: "Purabi Bhargava",
    service: "Move On",
    review:
      "I finally found closure and inner peace after months of struggling—thank you for the guidance!",
  },
  {
    name: "Nabha Shetty",
    service: "Check Compatibility",
    review:
      "Understanding compatibility made all the difference; I finally feel confident about my choice!",
  },
  {
    name: "Anushka Karmakar",
    service: "Patchup",
    review:
      "Thanks to the sessions, we rediscovered love and understanding in our marriage!",
  },
];
  return (
    <div className="form-footer-gradient">
      <div className="container background-light-red p-5">
    <Carousel
  interval={3000}
  controls={false}
  indicators={false}
  pause={false}
  touch={true}
  wrap={true}
  fade
>
  {testimonials.map((item, index) => (
   <Carousel.Item key={index}>
  <div className="testimonial-box">
    <p className="testimonial-review">
      "{item.review}"
    </p>
  </div>

  <div className="testimonial-user">
    <h4>{item.name}</h4>
    <span>Service: {item.service}</span>
  </div>
</Carousel.Item>
  ))}
</Carousel>
      </div>
      <div className="mt-5 container pt-5">
        <div className="row gap-0 ">
          <div className="col-7" ref={getStartedRef}>
  <div className="d-flex flex-column">
    <span
      style={{
        color: "#CC2B52",
        fontSize: "20px",
        fontFamily: "DM Sans",
        lineHeight: "32px",
      }}
    >
      Connect with us
    </span>
              <div>
                <span
                  className="carousel-container-recon d-flex "
                  style={{
                    color: "#212121",
                    fontSize: "54px",
                    fontFamily: "DM Sans",
                    lineHeight: "72px",
                    fontWeight: "400",
                  }}
                >
                  Finding{" "}
                  <span
                    className="carousel-text-recon mx-3"
                    style={{
                      color: "#CC2B52",
                      fontSize: "54px",
                      fontFamily: "DM Sans",
                      lineHeight: "72px",
                      fontWeight: "400",
                    }}
                  >
                    {/* reconnecting */}

                    {/* {words[index]} */}
                    <RollingText1 />
                  </span>{" "}
                </span>
              </div>
              <div>
                <span
                  className=""
                  style={{
                    color: "#212121",
                    fontSize: "54px",
                    fontFamily: "DM Sans",
                    lineHeight: "72px",
                    fontWeight: "400",
                  }}
                >
                  is a conscious decision. Let’s take this journey together.
                </span>
              </div>
            </div>
          </div>
          <div className="col-5">
            <div className="card p-5 card-shadow mb-3">
              <div className="d-flex flex-column">
                <label
                  style={{
                    fontSize: "16px",
                    fontWeight: "400",
                    fontFamily: "DM Sans",
                  }}
                >
                  Full Name
                </label>
                <input
                  type="text"
                  placeholder="Your Full Name"
                  className="form-control border border-1 border-dark py-2 mt-2"
                  style={{ outline: "none !important", boxShadow: "none" }}
                  onChange={(e) => {
                    setFormData({...formData, name: e.target.value})
                  }}
                  value={formData.name}
                ></input>
                <label
                  style={{
                    fontSize: "16px",
                    fontWeight: "400",
                    fontFamily: "DM Sans",
                  }}
                  className="mt-3"
                >
                  Email
                </label>
                <input
                  type="text"
                  placeholder="Your Email"
                  className="form-control border border-1 border-dark py-2 mt-2"
                  style={{ outline: "none !important", boxShadow: "none" }}
                  onChange={(e) => {
                    setFormData({...formData, email: e.target.value})
                  }}
                  value={formData.email}
                ></input>
                <label
                  style={{
                    fontSize: "16px",
                    fontWeight: "400",
                    fontFamily: "DM Sans",
                  }}
                  className="mt-3"
                >
                  Phone Number
                </label>
                <input
                  type="text"
                  placeholder="Your Phone Number"
                  className="form-control border border-1 border-dark py-2 mt-2"
                  style={{ outline: "none !important", boxShadow: "none" }}
                  onChange={(e) => {
                    setFormData({...formData, number: e.target.value})
                  }}
                  value={formData.number}
                ></input>
                <label
                  style={{
                    fontSize: "16px",
                    fontWeight: "400",
                    fontFamily: "DM Sans",
                  }}
                  className="mt-3"
                >
                 Tell Us About Your Situation
                </label>
                <textarea
                  type="text"
                  placeholder="Tell Us About Your Situation"
                  className="form-control border border-1 border-dark py-2 mt-2"
                  style={{ outline: "none !important", boxShadow: "none" }}
                  onChange={(e) => {
                    setFormData({...formData, desc: e.target.value})
                  }}
                  value={formData.desc}
                ></textarea>
              <button
  className="submit-btn mt-5"
  onClick={handleFormSubmit}
  disabled={isLoading}
>
  {isLoading ? (
    <>
      <span className="submit-spinner"></span>
      Submitting
    </>
  ) : (
    "Submit"
  )}
</button>
              </div>
            </div>
            <span
              className=""
              style={{
                color: "#3B486E",
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "20px",
                fontFamily: "DM Sans",
              }}
            >
              By submitting this form, you consent to receiving informational,
              advertising, or telemarketing messages via text (SMS/MMS) and
              email from Patchup. You agree to our Terms of Service and Privacy
              Policy. We respect your privacy and do not sell your data.
            </span>
          </div>
        </div>
      </div>
      <div className="mt-5 container  pb-3" ref={getStartedRef}>
        <div className="d-flex justify-content-between align-items-center">
         <div>
   <img
  src={logo}
  alt="Logo"
  style={{
    width: "120px",
    height: "auto",
    cursor: "pointer",
  }}
  onClick={() => {
    navigate("/");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }}
/>
</div>
        <div className="social-icons d-flex gap-3">
  <a
    href="https://twitter.com/yourusername"
    target="_blank"
    rel="noopener noreferrer"
  >
    <BsTwitterX />
  </a>

  <a
    href="https://linkedin.com/in/yourusername"
    target="_blank"
    rel="noopener noreferrer"
  >
    <BsLinkedin />
  </a>

  <a
    href="https://instagram.com/yourusername"
    target="_blank"
    rel="noopener noreferrer"
  >
    <BsInstagram />
  </a>
</div>
        </div>
        <hr></hr>
        <div className="d-flex justify-content-between">
          <div className="d-flex gap-3">
            <span
              style={{
                color: "#3B486E99",
                fontSize: "16px",
                fontWeight: "400",
                fontFamily: "DM Sans",
              }}
            >
              © Patchup 2025
            </span>
            <Link to={"/privacy-policy"} style={{ textDecoration: "none" }}>
              <span
                style={{
                  color: "#3B486E",
                  fontSize: "16px",
                  fontWeight: "600",
                  fontFamily: "DM Sans",
                }}
              >
                Privacy Policy
              </span>
            </Link>
            <Link
              to={"/terms-and-conditions"}
              style={{ textDecoration: "none" }}
            >
              <span
                style={{
                  color: "#3B486E",
                  fontSize: "16px",
                  fontWeight: "600",
                  fontFamily: "DM Sans",
                }}
              >
                Terms of use
              </span>
            </Link>
          </div>
          <div>
            {" "}
            <span
              style={{
                color: "#3B486E",
                fontSize: "16px",
                fontWeight: "600",
                fontFamily: "DM Sans",
              }}
            >
              Support@patchup.com
            </span>
          </div>
        </div>
      </div>
      <Toaster />
     <Modal
  show={show}
  onHide={handleClose}
  centered
  dialogClassName="success-modal"
>
  <Modal.Header closeButton className="border-0">
    <Modal.Title>
      {successError ? "Success" : "Warning"}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body className="text-center">
    {successError ? (
      <FaCheckCircle className="success-icon text-success mb-3" />
    ) : (
      <BiCommentError className="success-icon text-warning mb-3" />
    )}

    <p className="mb-0">
      {successError
        ? "Your information has been submitted successfully."
        : "Please fill in all the required fields."}
    </p>
  </Modal.Body>

  <Modal.Footer className="border-0 justify-content-center">
    <button className="modal-btn" onClick={handleClose}>
      Okay
    </button>
  </Modal.Footer>
</Modal>
    </div>
  );
};

export default Form;
